/*global SunergoPlatform*/

import initDatePickers from './form/datePickers';
import initSelect from './form/select';
import initTinymce from './form/tinymce';
import initFieldFeedback from './form/fieldFeedback';
import initFormSubmit from './form/formSubmit';
import initFileUploadField from './form/fieldFileUpload';
import initPasswordChecker from './form/passwordChecker';
import initDateTimeFormatting from './form/dateTimeFormatting';
import initEquation from './form/equation';
import initItemOrder from './form/itemOrder';
import initFieldSwitch  from './form/fieldSwitch';
import initAutoSubmit from './form/autoSubmit';
import initConditionalFields from './form/conditionalFields';
import initOptionalFieldset from './form/optionalFieldset';
import initTrackChanges from './form/trackChanges';
import initFormReset from './form/formReset';
import initCharacterLimits from './form/characterLimits';
import initSaveDialog from './form/saveDialog';
import initNCOLCheckout from './form/ncolCheckout';
import initRemoteFormSubmit from './form/remoteFormSubmit';
import initCheckboxSingleUnchecked from './form/checkboxSingleUnchecked';
import initCheckAll from './form/checkAll.js';
import initClearField from './form/clearField.js';
import initFormatCurrency from './form/formatCurrency.js';
import './form/spFormField';

// Import custom elements
import initRemoveFieldset from './form/removeFieldset.js';
import initInsertField from './form/insertField.js';
import initSumAmounts from './form/sumAmounts.js';

/**
 * Initializes forms on the page.
 */
function initForms() {
	const formList = document.querySelectorAll('[data-form]');
	if (!formList || formList.length < 1) return false;
	SunergoPlatform.forms = {};
	SunergoPlatform.inputElements = 'input, textarea, select';

	formList.forEach(form => {
		SunergoPlatform.forms[form.name] = {
			name: form.name,
			element: form,
			embedded: form.dataset.embedded,
			activeErrors: false,
		};
	});

	return true;
}

// Run scripts on document loaded.
const formJs = function() {
	// Initialize fields that are used anywhere, including outside forms.
	initDatePickers();
	initSelect();

	// Initialize forms.
	if (initForms()) {
		const forms = SunergoPlatform.forms;

		// Initialize fields that are within any form.
		initTinymce();

		// In each form, initialize the form's fields and processing.
		for (let form in forms) {
			initFieldFeedback(forms[form]);
			initFormSubmit(forms[form]);

			// Field-specific functionality.
			initFileUploadField(forms[form]);
			initPasswordChecker(forms[form]);
			initDateTimeFormatting(forms[form]);
			initEquation(forms[form]);
			initItemOrder(forms[form]);
			initFieldSwitch(forms[form]);
			initAutoSubmit(forms[form]);
			initCheckboxSingleUnchecked(forms[form]);
			initCheckAll(forms[form]);
			initClearField(forms[form]);
			initFormatCurrency(forms[form]);

			// Form and field processing.
			initConditionalFields(forms[form]);
			initOptionalFieldset(forms[form]);
			initTrackChanges(forms[form]);
			initFormReset(forms[form]);
			initCharacterLimits(forms[form]);

			// Pre-submission tasks.
			initSaveDialog(forms[form]); // run first
			initNCOLCheckout(forms[form]);

			// On-submission tasks (must run last).
			initRemoteFormSubmit(forms[form]);
		}
	}
};

SunergoPlatform.onLoad.push(formJs);

// Load custom elements.
const formCustomElements = () => {
	initRemoveFieldset();
	initInsertField();
	initSumAmounts();
};
SunergoPlatform.onLoad.push(formCustomElements);